import React from 'react';
import { Box, Link } from '@mui/material';
import { DatenschutzDialog } from './DatenschutzDialog';
import { ImpressumDialog } from './ImpressumDialog';
import { HelpdeskDialog } from './HelpdeskDialog';

export const Footer: React.FC = () => {
  const [openDatenschutz, setOpenDatenschutz] = React.useState(false);
  const [openImpressum, setOpenImpressum] = React.useState(false);
  const [openHelpdesk, setOpenHelpdesk] = React.useState(false);

  return (
    <Box component="footer" className="psf-footer">
      <div className="psf-footer__container">
        <div className="psf-footer__links">
          <Link component="button" type="button" className="psf-footer__link" onClick={() => setOpenDatenschutz(true)} underline="none">
            Datenschutz
          </Link>
          <Link component="button" type="button" className="psf-footer__link" onClick={() => setOpenImpressum(true)} underline="none">
            Impressum
          </Link>
          <Link component="button" type="button" className="psf-footer__link" onClick={() => setOpenHelpdesk(true)} underline="none">
            Helpdesk
          </Link>
        </div>
      </div>

      <DatenschutzDialog open={openDatenschutz} onClose={() => setOpenDatenschutz(false)} />
      <ImpressumDialog open={openImpressum} onClose={() => setOpenImpressum(false)} />
      <HelpdeskDialog open={openHelpdesk} onClose={() => setOpenHelpdesk(false)} />
    </Box>
  );
};
